import { useRef, useState } from "react";
import styled from "styled-components";
import { Swiper as NativeSwiper, SwiperSlide } from "swiper/react";

import "swiper/swiper-bundle.min.css";

const Root = styled.div`

    .swiper-slide {
        height: 100% !important;
    }
`
const Pagination = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
`;
const AbsolutePagination = styled(Pagination)`
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    z-index: 1;
`;
const Circle = styled.div`
    width: ${({paginationClickable}) => (paginationClickable ? "20px" : "10px")};
    height: ${({paginationClickable}) => (paginationClickable ? "20px" : "10px")};
    transition: all 0.3s;
    background: ${({ active }) => (!!active ? "#798090" : "transparent")};
    border: 1px solid #798090;
    border-radius: 50%;
    margin: 0 3.5px;
    cursor: ${({paginationClickable}) => (paginationClickable ? "pointer" : "default")};
`;

const Swiper = ({
    slides = [],
    isAbsoluteNavigation = false,
    showNavigation = true,
    paginationClickable = false,
    onSwiper,
    ...props
}) => {
    const [active, setActive] = useState(0);
    const swiperRef = useRef(null);

    const handleSwiper = (swiper) => {
        swiperRef.current = swiper;
        onSwiper?.(swiper);
    };


    const handlePaginationClick = (index) => {
        if (paginationClickable) {
            swiperRef.current?.slideTo(index);
        }
    };

    return (
        <Root>
            <NativeSwiper
                spaceBetween={50}
                slidesPerView={1}
                autoHeight={true}
                onSlideChange={({ activeIndex }) => setActive(activeIndex)}
                {...props}
                onSwiper={handleSwiper}
            >
                {slides.map((Component, index) => (
                    <SwiperSlide key={index}>{Component}</SwiperSlide>
                ))}
                {showNavigation && (
                    <>
                        {!!isAbsoluteNavigation && (
                            <AbsolutePagination>
                                {Array(slides.length)
                                    .fill()
                                    .map((_, index) => (
                                        <Circle
                                            active={index === active}
                                            paginationClickable={paginationClickable}
                                            key={index}
                                            onClick={() =>
                                                handlePaginationClick(index)
                                            }
                                        />
                                    ))}
                            </AbsolutePagination>
                        )}
                        {!isAbsoluteNavigation && (
                            <Pagination>
                                {Array(slides.length)
                                    .fill()
                                    .map((_, index) => (
                                        <Circle
                                            active={index === active}
                                            paginationClickable={paginationClickable}
                                            key={index}
                                            onClick={() =>
                                                handlePaginationClick(index)
                                            }
                                        />
                                    ))}
                            </Pagination>
                        )}
                    </>
                )}
            </NativeSwiper>
        </Root>
    );
};

export default Swiper;
